import React from 'react';
import LogoWhite from 'ui/assets/envio-white.png';
import { useHistory } from 'react-router';

const Header = ({ sticky }) => {
  const History = useHistory();
  return (
    <div className={sticky ? 'sticky-top' : ''}>
      <header className="navbar navbar-expand-md navbar-dark">
        <div className="container">
          <h1
            onClick={() => History.push('/')}
            className="navbar-brand navbar-brand-autodark d-none-navbar-horizontal pe-0 pe-md-3"
            style={{ cursor: 'pointer' }}
          >
            <img src={LogoWhite} alt="" className="navbar-brand-image" />
          </h1>
        </div>
      </header>
    </div>
  );
};

export default Header;
